import { BetStatus } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const betStatusDictionary = createSimpleDictionary([
    { id: BetStatus.Running, name: 'dictionaries.betStatus.running' },
    { id: BetStatus.Waiting, name: 'dictionaries.betStatus.waiting' },
    { id: BetStatus.Settled, name: 'dictionaries.betStatus.settled' },
    { id: BetStatus.Rejected, name: 'dictionaries.betStatus.rejected' },
    { id: BetStatus.Refunded, name: 'dictionaries.betStatus.refunded' },
    { id: BetStatus.Void, name: 'dictionaries.betStatus.void' },
    { id: BetStatus.Abnormal, name: 'dictionaries.betStatus.abnormal' },
]);
